<template>
	<div>
		<aside class="search-btn">
			<vButtonGroup class="tablelist-tabs clearfix" compact>
				<vButton
					size="large"
					v-for="(item,index) in btnsearch"
					:key="index"
					:theme="formData.itemstatus===item.value?'primary':'default'"
					@click="handleBtn('status',item.value)"
				>{{item.label}}</vButton>
			</vButtonGroup>
			<!--  结算明细 -->
            <div v-if="formData.itemstatus==1">
                <RadioGroup v-model="formData.chosetype" class="margin-top-10 margin-bottom-10">
                    <Radio label="0" >仓库作业费</Radio>
                    <Radio label="1" >仓储费</Radio>
                    <Radio label="2" >增值服务费</Radio>
                </RadioGroup>
                <compCostall v-if="formData.chosetype == 0"></compCostall>
                <compStorage v-if="formData.chosetype == 1"></compStorage>
                <compZengzhi v-if="formData.chosetype == 2"></compZengzhi>
            </div>
			<!-- 结算异常明细 -->
            <div v-if="formData.itemstatus==0">
                <RadioGroup v-model="formData.chosetype" class="margin-top-10 margin-bottom-10">
                    <Radio label="0" >仓库作业费</Radio>
                    <Radio label="1" >仓储费</Radio>
                    <Radio label="2" >增值服务费</Radio>
                </RadioGroup>
                <compErrdetail v-if="formData.chosetype == 0"></compErrdetail>
                <compErrstorage v-if="formData.chosetype == 1"></compErrstorage>
                <compErrzengzhi v-if="formData.chosetype == 2"></compErrzengzhi>
            </div>
		</aside>
	</div>
</template>
<script>
import compCostall from "./detail/accountdetail.js";
import compStorage from "./detail/storage"
import compZengzhi from "./detail/zengzhi"


import compErrdetail from "./error/errordetail.js";
import compErrstorage from "./error/errstorage.js";
import compErrzengzhi from "./error/errzengzhi.js";

export default {
	components: {
		compCostall,
        compStorage,
        compZengzhi,

		compErrdetail,
        compErrstorage,
        compErrzengzhi,
	},
	data() {
		return {
			btnsearch: [{
				value: 1,
				label: '结算明细'
			}, {
				value: 0,
				label: '结算记录'
			},],
			formData: {
				itemstatus: 1,
                chosetype:'0',
			}
		}
	},
	computed: {
		columns() {
			return [

			]
		}
	},
	methods: {
		handleBtn(type, value) {
			// console.log(2222)
			this.formData.itemstatus = value
		}
	},
}
</script>
